
















































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { Letter } from '@/store/models/Letter/Letter';
import { saveFile, converBase64toBlob, getPersianDate } from '@/util/utils';
import LetterAttachment from '@/components/Cartable/LetterDetails/LetterAttachment/LetterAttachment.vue';
import GroupedByCompanyOwner from '@/components/Cartable/GroupedByCompanyOwner/GroupedByCompanyOwner.vue';
import * as fileService from '@/store/Services/fileService';
import * as letterService from '@/store/Services/letterServices';
import Parts from '@/store/models/Letter/Parts';
import { LetterTrail } from '@/store/models/Letter/LetterTrail';
import * as $ from 'jquery';
import * as util from '@/util/utils.ts';
import { LetterSearchResult } from '../../../store/models/Letter/LetterSearchResult';
import * as enterpriseFormService from '@/store/Services/enterpriseFormService';
import store from '@/store';
import { EnterpriseForm } from '@/store/models/EnterpriseForm/EnterpriseForm';
import * as letterPossessionCommentService from '@/store/Services/letterPossessionCommentService';
import {ReceivedMessageFromFaxServiceDto} from '@/store/models/LetterOwner/RecievedMessageFromFaxServiceDto';
import { DateBaseOnCurrentTimeConverter } from '@/util/dateConverter';
import File from '@/store/models/Letter/File';
import InPlaceMessageBox from '@/components/UiComponents/InPlaceMessageBox.vue';
import * as faxService from '@/store/Services/FaxService';
import {GroupedLetterOwnersByCompanyDto} from '@/store/models/LetterOwner/GroupedLetterOwnersByCompanyDto'

@Component({
    name:"FaxDetails",
    components:{LetterAttachment, InPlaceMessageBox, GroupedByCompanyOwner}
})
export default class FaxDetails extends Vue {
    @Prop() fax?: ReceivedMessageFromFaxServiceDto;
    @Prop() letterOwners?: GroupedLetterOwnersByCompanyDto[];
  
    shallShowMsgBox = false;
    msgBoxMessage = "آیا مطمئن هستید؟";
    msgBoxButtons = "yesNo";
    msgBoxMessageType = "fail";

    serverTime?: string;
    get  sendTime(){
        if(this.fax === undefined) return '';
        if(!this.serverTime) return '';
        const dateConverter = new  DateBaseOnCurrentTimeConverter();
        return   dateConverter.getDateString(new Date(this.fax.time.substring(0,this.fax.time.length -1)),this.serverTime)
    }

    get attachments(){
        if(!this.fax)
            return [];
        if(!this.fax.attachments)
            return [];
        
        const files = [] as  File[];
        this.fax.attachments.forEach(f=>{
            const file = {} as File;
            file.extension = f.name;
            file.id = f.id;
            files.push(file);
        });
        return files;
    }

    async created(){
        this.serverTime = await letterService.getServerTime();
    }
    action = "";
    deleteFax(){
        this.msgBoxMessage = "آیا مطمئن هستید؟";
        this.msgBoxMessageType = "fail";
        this.msgBoxButtons = "yesNo";
        this.shallShowMsgBox = true;
        this.action = "delete";
    }

    routFax(){
        if(this.selectedOwnerId == ""){
            this.msgBoxMessage = "هیچ موردی برای اتصال انتخاب نشده است";
            this.msgBoxMessageType = "fail";
            this.msgBoxButtons = "ok";
            this.shallShowMsgBox = true;
            this.action = "rout";
        }
        else{
            this.msgBoxMessage = "آیا از اتصال فکس/ایمل مطمئن هستید؟";
            this.msgBoxMessageType = "success";
            this.msgBoxButtons = "yesNo";
            this.shallShowMsgBox = true;
            this.action = "rout";
        }
    }
    
    async onMsgBoxButtonClicked(btn: any){
        if(!this.fax)
            return;
        if(btn == "yes"){
            if(this.action == "delete"){
                await faxService.deleteFax(this.fax.id);
                this.$emit("fax-deleted");
            }
            if(this.action == "rout"){
                await faxService.routMessage(this.fax.id, this.selectedOwnerId);
                 this.$emit("fax-routed");
            }
        }

        this.shallShowMsgBox = false;
    }

    searchText = "";
    get filteredLetterOwners(){
        if(!this.letterOwners)
            return this.letterOwners;
        if(this.searchText === "")
            return this.letterOwners;
        const result = this.letterOwners.filter(x=>x.companyName.includes(this.searchText)
        ||(x.owners &&  (x.owners.filter(o=>o.name.includes(this.searchText))).length > 0)
        ||(x.owners &&  (x.owners.filter(o=>o.post.includes(this.searchText))).length > 0)
        );
        return result;
    }

    selectedOwnerText = "";
    selectedOwnerId = "";
    onOwnerSelected(obj: any){
        this.selectedOwnerId = obj.ownerId;
        if(obj.companyName == "نامشخص"){
            this.selectedOwnerText = obj.ownerName
        }
        else{
            this.selectedOwnerText = obj.ownerName + " از " + obj.companyName;
        }
    }
}
